package com.anjuros.website.templates.template10.util

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType


enum class ResKey : ResKeyType {

    TEMPLATE10_SECTION1,
    TEMPLATE10_SECTION2,
    TEMPLATE10_SECTION3,
    TEMPLATE10_SECTION4,
    TEMPLATE10_SECTION5,
    TEMPLATE10_HERO_TITLE,
    TEMPLATE10_HERO_SUBTITLE,
    TEMPLATE10_HERO_BADGE1,
    TEMPLATE10_SERVICE1_TIME,
    TEMPLATE10_SERVICE2_TIME,
    TEMPLATE10_SERVICE3_TIME,
    TEMPLATE10_BOOK_CLASS,
    TEMPLATE10_PER_CLASS,
    TEMPLATE10_ALL_VENUES,
    TEMPLATE10_BENEFITS_TITLE,
    TEMPLATE10_INFO_TITLE1,
    TEMPLATE10_INFO_DESC1,
    TEMPLATE10_INFO_TITLE2,
    TEMPLATE10_INFO_DESC2,
    TEMPLATE10_INFO_TITLE3,
    TEMPLATE10_INFO_DESC3,
    TEMPLATE10_ABOUT_TITLE,
    TEMPLATE10_ABOUT_PARAGRAPH1,
    TEMPLATE10_ABOUT_PARAGRAPH2,
    TEMPLATE10_EXPERIENCE_YEARS,
    TEMPLATE10_BADGE1,
    TEMPLATE10_BADGE2,
    TEMPLATE10_BADGE3,
    TEMPLATE10_VIDEOS_TITLE,
    TEMPLATE10_VIDEOS_DESC,
    TEMPLATE10_TIMETABLE_EYEBROW,
    TEMPLATE10_TIMETABLE1_TITLE,
    TEMPLATE10_CLASS_DAY,
    TEMPLATE10_CLASS_MON,
    TEMPLATE10_CLASS_TUE,
    TEMPLATE10_CLASS_WED,
    TEMPLATE10_CLASS_THU,
    TEMPLATE10_CLASS_FRI,
    TEMPLATE10_CONTACT_TITLE,
    TEMPLATE10_CONTACT_CALL,
    TEMPLATE10_CONTACT_WRITE,
    TEMPLATE10_CONTACT_CARD_TITLE,
    TEMPLATE10_CONTACT_CARD_TEXT,
    TEMPLATE10_FOOTER_RIGHTS;

    override val keyName: String
        get() = name
}


val TextResources = mapOf(
    Language.EN to mapOf(
        ResKey.TEMPLATE10_SECTION1 to "Benefits",
        ResKey.TEMPLATE10_SECTION2 to "About me",
        ResKey.TEMPLATE10_SECTION3 to "Videos",
        ResKey.TEMPLATE10_SECTION4 to "Timetable",
        ResKey.TEMPLATE10_SECTION5 to "Contact",
        ResKey.TEMPLATE10_HERO_TITLE to "Seek stillness in motion.",
        ResKey.TEMPLATE10_HERO_SUBTITLE to "Traditional Tai Chi · all ages · Staffordshire",
        ResKey.TEMPLATE10_HERO_BADGE1 to "TAI CHI CHUAN · 20+ YEARS",
        ResKey.TEMPLATE10_SERVICE1_TIME to "Mon-Fri from 11:00",
        ResKey.TEMPLATE10_SERVICE2_TIME to "Mon-Fri from 15:00",
        ResKey.TEMPLATE10_SERVICE3_TIME to "Mon-Fri at 09:00",
        ResKey.TEMPLATE10_BOOK_CLASS to "BOOK A CLASS",
        ResKey.TEMPLATE10_PER_CLASS to "per class",
        ResKey.TEMPLATE10_ALL_VENUES to "all venues",
        ResKey.TEMPLATE10_BENEFITS_TITLE to "Three gifts of Tai Chi",
        ResKey.TEMPLATE10_INFO_TITLE1 to "Balance",
        ResKey.TEMPLATE10_INFO_DESC1 to "Stronger legs, steadier steps and fewer falls.",
        ResKey.TEMPLATE10_INFO_TITLE2 to "Calm",
        ResKey.TEMPLATE10_INFO_DESC2 to "Deep breathing that quiets stress and anxiety.",
        ResKey.TEMPLATE10_INFO_TITLE3 to "Strength & flexibility",
        ResKey.TEMPLATE10_INFO_DESC3 to "Gentle on joints, good for every age.",
        ResKey.TEMPLATE10_ABOUT_TITLE to "“Every class is a step toward harmony of body and mind.”",
        ResKey.TEMPLATE10_ABOUT_PARAGRAPH1 to "Hi! I'm a Tai Chi instructor with over 20 years of experience. My journey started when I discovered Tai Chi as a young adult. I was fascinated by its combination of movement, mindfulness and holistic wellness.",
        ResKey.TEMPLATE10_ABOUT_PARAGRAPH2 to "Since then, I have dedicated my life to sharing the art, helping students improve balance, strength and inner peace. Teaching is my passion.",
        ResKey.TEMPLATE10_EXPERIENCE_YEARS to "years of practice",
        ResKey.TEMPLATE10_BADGE1 to "ATCQA certified",
        ResKey.TEMPLATE10_BADGE2 to "Tai Chi Foundation",
        ResKey.TEMPLATE10_BADGE3 to "All abilities welcome",
        ResKey.TEMPLATE10_VIDEOS_TITLE to "See it in motion",
        ResKey.TEMPLATE10_VIDEOS_DESC to "Short clips from real classes, so you know exactly what to expect before your first session.",
        ResKey.TEMPLATE10_TIMETABLE_EYEBROW to "Weekly timetable",
        ResKey.TEMPLATE10_TIMETABLE1_TITLE to "Find a class near you",
        ResKey.TEMPLATE10_CLASS_DAY to "Day",
        ResKey.TEMPLATE10_CLASS_MON to "Monday",
        ResKey.TEMPLATE10_CLASS_TUE to "Tuesday",
        ResKey.TEMPLATE10_CLASS_WED to "Wednesday",
        ResKey.TEMPLATE10_CLASS_THU to "Thursday",
        ResKey.TEMPLATE10_CLASS_FRI to "Friday",
        ResKey.TEMPLATE10_CONTACT_TITLE to "The journey of a thousand miles begins with one step.",
        ResKey.TEMPLATE10_CONTACT_CALL to "CALL",
        ResKey.TEMPLATE10_CONTACT_WRITE to "WRITE",
        ResKey.TEMPLATE10_CONTACT_CARD_TITLE to "Write me a note",
        ResKey.TEMPLATE10_CONTACT_CARD_TEXT to "Questions, first-timers, all welcome.",
        ResKey.TEMPLATE10_FOOTER_RIGHTS to "All rights reserved.",
    ),
)
